export const attachReselectCheckboxesEvent = (form) => {
  const isCompareForm = currentForm => currentForm && currentForm.name === 'compareForm';

  const reselectCompareCheckbox = (compareForm, productId) => {
    const compareCheckbox = compareForm
      .querySelector(`input[type=checkbox][name="productID"][value="${productId}"]`);

    if (compareCheckbox) {
      compareCheckbox.checked = true;
    }
  };

  if (isCompareForm(form)) {
    form.addEventListener('reselect-compare-checkboxes', ({ target: compareForm }) => {
      if (!isCompareForm(form)) return false;

      const selectedProductIds = compareForm.querySelector('.js-compare-bar-items-id');
      if (selectedProductIds && selectedProductIds.value !== '') {
        selectedProductIds.value.split(',').forEach((productId) => {
          reselectCompareCheckbox(compareForm, productId);
        });
      }
    });
  }
};
